/**
 * Wrapper around window.location.assign to allow mocking in tests.
 *
 * @param {string} url - The URL to navigate to.
 */
export const windowLocationAssign = url => {
  window.location.assign(url);
};
